// removed by extract-text-webpack-plugin
module.exports = {"pdpFolderItem":"RelatedFolderItem-style__pdpFolderItem__4afc80bb"};


//////////////////
// WEBPACK FOOTER
// ./assets/js/newPdp/components/Favorites/RelatedFolderItem-style.scss
// module id = 3503
// module chunks = 4